module.exports = __webpack_public_path__ + "img/linkedin.9abd8aa.svg";